export default {
	SIM: {
		text: 'Sim',
		value: 'SIM',
	},
	NAO: {
		text: 'Não',
		value: 'NAO',
	},
}
